<template>
<v-layout row wrap>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <!--
      <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      -->
      <v-btn color="pink" dark small fixed top right fab style="top:44px" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                :items="['daejeon', 'test']"
                v-model="editedItem.group"
                label="group"
                single-line
                />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.id" label="플러그 시리얼넘버"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.fwVersion" label="펌웨어 버전"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.iemi" label="iemi"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.usim" label="usim"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$_close">취소</v-btn>
        <v-btn color="blue darken-1" flat @click="$_save">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :headers="headers"
        :items="datas"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.group }}</td>
            <td class="text-xs-left">{{ props.item.status ? $_isOnline(props.item) : '' }}</td>
            <td class="text-xs-left">{{ props.item.status ? ($_isOnCharging(props.item) ? '충전중' : '') : '' }}</td>
            <td class="text-xs-left">{{ props.item.status ? $_readableCheckedTime(props.item.status.updated.toDate()) : '' }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="$_editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="$_deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text>
              펌웨어 버전 : {{ props.item.fwVersion }}<br>
              iemi : {{ props.item.fwVersion }}<br>
              usim : {{ props.item.usim }}<br>
              상태 확인 시각 {{ props.item.status.updated.toDate() }}
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <!--
  <v-btn fixed dark fab bottom right color="pink"
    @click="$router.push({name:'PlugAdd'})">
    <v-icon>add</v-icon>
  </v-btn>
  -->
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import moment from 'moment/moment'
import {Util} from '../Util'

export default {
  name: 'HelloWorld',
  data () {
    return {
      headers: [{text: 'serialNumber', values: 'serialNumber', sortable: false},
        {text: 'group', values: 'group', sortable: false},
        {text: 'online', values: 'online', sortable: false},
        {text: 'oncharging', values: 'oncharging', sortable: false},
        {text: '확인시각', values: 'logtime', sortable: false},
        {text: '관리', values: 'actions', sortable: false}],
      datas: [],
      rowsPerPageItems: [10, 20, 50, 100, 200],
      pagination: {
        rowsPerPage: 200
      },
      dialog: false,
      editedIndex: -1,
      editedItem: {
        group: this.$store.state.session.group,
        id: '',
        fwVersion: '',
        iemi: '',
        usim: ''
      },
      defaultItem: {
        group: this.$store.state.session.group,
        id: '',
        fwVersion: '',
        iemi: '',
        usim: ''
      },
      loading: false
      // items: [{ header: '플러그 목록' }]
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '플러그 신규 등록' : '플러그 정보 수정'
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getPlugs()
    },
    dialog (val) {
      val || this.$_close()
    }
  },
  created () {
    this.$emit('title', '플러그 관리')
    this.$_getPlugs()
  },
  methods: {
    $_getPlugs () {
      this.loading = true

      let query = this.$fs.collection('plugs')
      if (!this.$store.state.session.admin) {
        query = query.where('group', '==', this.$store.state.session.group)
      }

      query
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.datas.push(item)
            // this.items.push({ divider: true, inset: false })
            // console.log(doc.data())
          })
          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.loading = false
        })
    },
    $_editItem (item) {
      // console.log('edit', item)

      this.editedIndex = this.datas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    $_deleteItem (item) {
      if (item.chargerRef) {
        alert('해당 플러그가 충전기에 할당 되어 있습니다.\n충전기-플러그 구성에서 먼저 제거하세요.')
        return
      }

      const index = this.datas.indexOf(item)
      const name = this.datas[index].id
      const plugId = this.datas[index].id
      const inputPlugName = prompt('해당 "' + name + '" 플러그를 정말 삭제하시겠습니까?\n해당 플러그 시리얼넘버를 한번 더 정확하게 입력하세요.')

      if (name === inputPlugName) {
        // TODO loading

        /*
        // 연결되어 있는 charger 정보 삭제
        // transaction 을 사용하여 reference 가 실제 존재하지 않는 경우를 처리하려고 했으나
        // Every document read in a transaction must also be written. 오류 발생으로 원복함.
        // transaction 은 해당 문서가 있을 경우 read 후 반드시 write 를 해야 함.
        const chargerRef = this.datas[index].chargerRef
        const plugRef = this.$fs.collection('plugs').doc(plugId)
        let job = null

        if (chargerRef) {
          job = this.$fs.db().runTransaction(t => {
            return t.get(chargerRef)
              .then(doc => {

                try {
                  if (doc.exists) {
                    t.update(chargerRef, {'plugRef': firebase.firestore.FieldValue.delete(),
                                  updated: firebase.firestore.FieldValue.serverTimestamp()})
                  }

                  t.delete(plugRef)
                  return Promise.resolve(doc)
                } catch (error) {
                  return Promise.reject(error)
                }
              })
          })
        } else {
          job = plugRef.delete()
        }
        */

        this.$fs
          .collection('plugs')
          .doc(plugId)
          .delete()
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.splice(index, 1)

            this.$emit('snackbar', '삭제되었습니다.')
            this.$_close()
          }).catch(error => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else if (inputPlugName) {
        this.$emit('snackbar', '충전소 이름을 다시 확인하세요.')
      }
    },
    $_close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    $_save () {
      if (this.editedIndex > -1) { // 수정
        // TODO loading
        const item = this.datas[this.editedIndex]
        const plugId = item.id
        const group = item.group

        if (group !== this.editedItem.group) {
          if (item.chargerRef) {
            alert('해당 플러그가 충전기에 할당 되어 있습니다.\n그룹 변경을 위해서 충전기-플러그 구성에서 먼저 제거하세요.')
            return
          }
        }

        this.$fs.collection('plugs')
          .doc(plugId)
          .set({group: this.editedItem.group,
            fwVersion: this.editedItem.fwVersion,
            iemi: this.editedItem.iemi,
            usim: this.editedItem.usim,
            updated: firebase.firestore.FieldValue.serverTimestamp()}, {merge: true})
          .then(() => {
            // 로컬 데이터 업데이트
            Object.assign(this.datas[this.editedIndex], this.editedItem)

            this.$emit('snackbar', '수정되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else { // 신규
        // TODO loading
        const plugId = this.editedItem.id
        this.$fs.collection('plugs')
          .doc(plugId)
          .set({group: this.$store.state.session.group,
            fwVersion: this.editedItem.fwVersion,
            iemi: this.editedItem.iemi,
            usim: this.editedItem.usim,
            created: firebase.firestore.FieldValue.serverTimestamp()}, {merge: true})
          .then(() => {
            // 로컬 데이터 업데이트
            Object.assign(this.datas[this.editedIndex], this.editedItem)

            this.$emit('snackbar', '등록되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      }
    },
    $_readableCheckedTime (date) {
      const duration = moment.duration(moment().diff(date))
      const diffHours = duration.asHours()

      if (diffHours > 24) {
        return Math.floor(duration.asDays()) + ' 일전'
      } else if (diffHours > 1) {
        return Math.floor(diffHours) + ' 시간전'
      } else {
        return Math.floor(moment.duration(moment().diff(date)).asMinutes()) + ' 분전'
      }
    },
    $_isOnline (plug) {
      return Util.Plug.isOnline(plug)
    },
    $_isOnCharging (plug) {
      return Util.Plug.isOnCharging(plug)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Plug/PlugList.vue